export default "__VITE_ASSET__b9kYHjOE__"